import { render, staticRenderFns } from "./PlacesList.vue?vue&type=template&id=3fa31326&"
import script from "./PlacesList.vue?vue&type=script&lang=js&"
export * from "./PlacesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa31326')) {
      api.createRecord('3fa31326', component.options)
    } else {
      api.reload('3fa31326', component.options)
    }
    module.hot.accept("./PlacesList.vue?vue&type=template&id=3fa31326&", function () {
      api.rerender('3fa31326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/PlacesList.vue"
export default component.exports